module.exports = "/_next/static/images/og-image-remote-work-guides_f0fc0a672cd8bbef5f44ffe40b87b45c.jpg";